import { CSelect } from "components";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { CSelectProps } from ".";

export const CSelectGender: FC<CSelectProps> = (props) => {
  const { t } = useTranslation();
  return (
    <CSelect
      {...props}
      placeholder={t("gender")}
      valueOption={{
        values: [
          { value: "MALE", title: t("male") },
          { value: "FEMALE", title: t("female") },
          { value: "UNSPECIFIED", title: t("unspecified") },
        ],
        valueKey: "value",
        labelKey: "title",
      }}
    />
  );
};
